import { Observable } from 'rxjs';
import { GetContentDto, GetContentResp } from '../usecase/content/get-content.interface';
import { AdditionalHeader } from '../../app/presentations/landing/landing';
import { GetCustParamResp } from '../usecase/cust-param/get-cust-param.type';
import { PoinListDto, PoinListResp } from '../usecase/poin/poin.type';
import { GetClaimVoucherDto, GetClaimVoucherResp } from '../usecase/voucher/get-claim-voucher/get-claim-voucher.type';
import { PostValidateHaloNumberDto, PostValidateHaloNumberResp } from '@usecase/voucher/post-validate-halo-number/post-validate-halo-number.type';

export abstract class PromoRepository {
  abstract GetDataContent(params: GetContentDto): Observable<GetContentResp>;
  abstract GetCustParam(header: AdditionalHeader[]): Observable<GetCustParamResp>;
  abstract GetPoinList(payload: PoinListDto): Observable<PoinListResp>;
  abstract GetClaimVoucher(payload: GetClaimVoucherDto): Observable<GetClaimVoucherResp>;
  abstract PostValidateHaloNumber(payload: PostValidateHaloNumberDto): Observable<PostValidateHaloNumberResp>;
}
